import { render } from "./PhoneNumberVerificationPopup.vue?vue&type=template&id=2a929e1e&scoped=true&ts=true"
import script from "./PhoneNumberVerificationPopup.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberVerificationPopup.vue?vue&type=script&lang=ts"

import "./PhoneNumberVerificationPopup.vue?vue&type=style&index=0&id=2a929e1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a929e1e"]])

export default __exports__